import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field, FieldArray } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'
import { WindowReload, WindowURL, WindowLocation, WindowLocationBaseUrl } from '../../../../services/redirect'

import Spinner from '../../../../services/spinner'
import AlertMessage from '../../../../services/alert'
import { HookDataComponent } from './hooksData'

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default function SendEmail(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner||itemsProcess>0){
      return false;
    }
    props.callback(data);
  }

  const sequentialState = props.total_data>3000?true:false;


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


   


   /*----------------------------------------
     Range Reports
   -----------------------------------------*/
   const limitRecords = 3000;
   const [itemsProcess, setItemsProcess] = useState(0);
   const [itemsReports, setItemReports] = useState([]);
   const [stateReports, setStateReports] = useState({
    reportsArray:[]
  });
   function RangeReportsFunction(total){
 
      const totalRecords = total;
      const pageSize     = limitRecords;
 
       // Generate ranges
       const ranges = [];
       for (let i = 1; i <= totalRecords; i += pageSize) {
         ranges.push({ 
          id:i,
          start: i, 
          end: Math.min(i + pageSize - 1, totalRecords),
          spinner:false,
          button:false,
          status:{
             success:false,
             failed:false,
             running:true,
          }
        });
       }
       setItemReports(ranges);
       setStateReports({reportsArray:ranges});
 
  }
  

  // Handle click all button inside reports
  const btnRefs = useRef({});
  const [running, setRunning] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const setRef = (id) => (el) => {
    btnRefs.current[id] = el;
  }

  const handleClickAll = async (interval = 600) => {
    if (running) return;
    setRunning(true);
    setItemsProcess(itemsReports.length);
    for (let i = 0; i < itemsReports.length; i++) {
      setActiveIndex(i);
      const item = itemsReports[i];
      const btn = btnRefs.current[item.id];
      if (btn && typeof btn.click === "function") {
        btn.click(); // simulate real DOM click
      } else {
        console.warn("No DOM button available for", item.id);
      }
      await delay(interval);
    }
    setActiveIndex(-1);
    setRunning(false);
  }

  

  /*----------------------------------------
    Handle Submit
  -----------------------------------------*/
  function handleSubmitForm(){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:"Sending report, please wait..."}});
    setspinoverlay(true);

    let valueData = {
      admin_id:props.data.admin_id,
      status:props.data.status,
      date_from:props.data.date_order_from!=''?moment(new Date(props.data.date_order_from)).format('YYYY-MM-DD'):'',
      date_to:props.data.date_order_to!=''?moment(new Date(props.data.date_order_to)).format('YYYY-MM-DD'):''
    }
    

    let formData = new FormData();
    formData.append('type','sendMail');
    formData.append('info',JSON.stringify(valueData));
    axios.post('/excel/reports/orders/orders_status/csvSentToMail.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinoverlay(false);

      if(obj=='1'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Processed orders reports successfully sent.'}});
        setnotify(true);
        setTimeout(function() {
          CallbackModal({close:true});
          setnotify(false);
        },3000);
        return false;
      }else{
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }


    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*----------------------------------------
    GET EMAILS
  -----------------------------------------*/
  const [status, setStatus] = useState(true);
  const [emails, setEmails] = useState([]);
  function handleGetEmails(status){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinoverlay(true);

    let formData = new FormData();
    formData.append('type','getEmails');
    formData.append('status',status);
    axios.post('/admin/reports/processed-orders/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      if(obj.length>0){
        setStatus(false);
        setEmails(obj);
      }
      
      setspinoverlay(false);


    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }



  useEffect(()=>{
    handleGetEmails(4);
    RangeReportsFunction(props.total_data);
  },[]);


  return (
    <React.Fragment>
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
              {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div>
                      <h2>Send Processed Orders</h2>
                    </div>
                    <div onClick={()=>CallbackModal({close:itemsProcess>0?false:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <div class="alert-message left info infohasborder">
                          <div><i class="info circle icon"></i></div>
                          <div>
                            <p>List of email addresses that can receive custom date processed order reports when you click the confirm button.</p>
                          </div>
                        </div>

    
                        {!spinner&&<Table striped>
                          <Table.Body>
                          {emails.length==0&&<Table.Row negative><Table.Cell textAlign="center">No email found. Please add email for custom date processed orders.</Table.Cell></Table.Row>}
                          {emails.map(function(data, key){
                            return <Table.Row key={key}>
                              <Table.Cell>{data.email}</Table.Cell>
                            </Table.Row>
                          })}
                          </Table.Body>
                        </Table>}
                        
                        {/*sequentialState&&<React.Fragment>
                         <Formik 
                            enableReinitialize
                            initialValues={stateReports}
                          >
                            {({ values, handleChange, handleSubmit, setFieldValue }) => {
                            return(
                            <FieldArray
                                name="reportsArray"
                                render={arrayHelpers => (
                                <Table celled compact='very' className="ordersTable">
                                    <Table.Header>
                                      <Table.Row verticalAlign='middle'>
                                        <Table.HeaderCell>Records</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Action</Table.HeaderCell>
                                      </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {values.reportsArray.map((range, index) => (
                                        <Table.Row key={index} verticalAlign='top'>
                                            <Table.Cell>
                                               Records From {range.start.toLocaleString()} - {range.end.toLocaleString()}
                                            </Table.Cell>
                                            <Table.Cell collapsing>
                                              <Loader active={values.reportsArray[index].spinner} inline size='mini'/>

                                              {values.reportsArray[index].spinner?' Processing...':(values.reportsArray[index].status.success||values.reportsArray[index].status.failed)?'':'Ready'}

                                              {((values.reportsArray[index].status.success||values.reportsArray[index].status.failed)&&!values.reportsArray[index].spinner)&&<span className={values.reportsArray[index].status.success?'status-icon-wrapper positive':'status-icon-wrapper negative'}>
                                                <Icon name={values.reportsArray[index].status.success?'check circle':'close'} />
                                                <span>{values.reportsArray[index].status.success?'Sent Successfully':'Failed to send'}</span>
                                              </span>}


                                            </Table.Cell>
                                            <Table.Cell collapsing>
                                            <button 
                                               type='button'
                                               className='ui button tiny GreenButton' 
                                               key={range.id}
                                               ref={setRef(range.id)} 
                                               disabled={values.reportsArray[index].spinner||values.reportsArray[index].button}  
                                               onClick={()=>{

                                                    const dataValue = {
                                                        range_start: range.start,
                                                        range_end: range.end,
                                                        admin_id:props.data.admin_id,
                                                        status:props.data.status,
                                                        date_from:props.data.date_order_from!=''?moment(new Date(props.data.date_order_from)).format('YYYY-MM-DD'):'',
                                                        date_to:props.data.date_order_to!=''?moment(new Date(props.data.date_order_to)).format('YYYY-MM-DD'):''
                                                    }

                                                    setFieldValue(`reportsArray[${index}].spinner`,true);
                                                    setFieldValue(`reportsArray[${index}].button`,false);

                                                  // Send to end point server
                                                  const handleCartHooks = async (param) => {
                                                      
                                                        const response = await HookDataComponent(param);

                                                        setItemsProcess(prev => parseInt(prev) - 1);
  
                                                        if(response.status==500||response.code=='ERR_BAD_RESPONSE'){
                                                            setTimeout(function() {
                                                              setFieldValue(`reportsArray[${index}].spinner`,false);
                                                              setFieldValue(`reportsArray[${index}].button`,false);
                                                              setFieldValue(`reportsArray[${index}].status.running`,false);
                                                              setFieldValue(`reportsArray[${index}].status.failed`,true);
                                                            });
                                                            return false;
                                                        }
                          
                                                        if(response=='1'){
                                                          setTimeout(function() {
                                                            setFieldValue(`reportsArray[${index}].spinner`,false);
                                                            setFieldValue(`reportsArray[${index}].button`,false);
                                                            setFieldValue(`reportsArray[${index}].status.running`,false);
                                                            setFieldValue(`reportsArray[${index}].status.success`,true);
                                                          });
                                                          return false;
                                                        }else{
                                                          setTimeout(function() {
                                                            setFieldValue(`reportsArray[${index}].spinner`,false);
                                                            setFieldValue(`reportsArray[${index}].button`,false);
                                                            setFieldValue(`reportsArray[${index}].status.running`,false);
                                                            setFieldValue(`reportsArray[${index}].status.failed`,true);
                                                          });
                                                          return false;
                                                        }


                                                    }
                                                    handleCartHooks(dataValue);
                                                    // Save cart update to server end
                                              }}>
                                               Send
                                              </button>

                                            </Table.Cell>
                                        </Table.Row>
                                      ))}
                                    </Table.Body>
                                </Table>
                                )}/>
                              )}}
                          </Formik>
                          </React.Fragment>
                          */}

                  

                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                     <Button disabled={status||!props.data.is_Search} size="medium" fluid className='BlueButton strong' content='CONFIRM SEND' onClick={() => handleSubmitForm()}/>
                     
                 </div>


              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
    </React.Fragment>
  )
}
